import { PayloadAction } from "@reduxjs/toolkit";
import { usersPageApi } from "api/UsersPageApi";
import { toast } from "react-toastify";
import { call, put } from "redux-saga/effects";
import { getUserPageUserInfo } from "redux/userPage/userPageActions";
import { parseError } from "shared/src/helpers/errorHandler";

export function* deleteUserSaga(
  action: PayloadAction<{ id: string; reason?: string; actionPage: "table"; "user-page" }>
) {
  const { id, reason, actionPage } = action.payload;
  try {
    yield call([usersPageApi, usersPageApi.deleteUser], id, reason);
    yield put(getUserPageUserInfo({ id }));
    yield call([toast, toast.success], "User deleted");
  } catch (e) {
    yield call([toast, toast.error], parseError(e)?.message);
    console.error(e);
  }
}
